import { Button } from "@/components/ui/elements";

export function TrustdockUploderButton() {
  return (
    <Button className="trustdock-uploader-opener">本人確認書類提出</Button>
  );
}
